<template>

    <CForm>
        <div class="overflow-hidden border border-gray-300 rounded-md delivery_address_form">

            <div class="flex items-center bg-gray-100">
                <div class="w-2/6 py-2 font-bold pl-2">Доставка до</div>
                <div class="w-2/6 py-2 font-bold">Стоимость доставки (руб.)</div>
                <div class="w-1/6 py-2 font-bold">Полностью бесплатно</div>
                <div class="w-1/6 py-2 font-bold"></div>
            </div>

            <div
                v-for="item in list"
                :key="item.id"
                class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
            >
                <div v-if="item.add" class="w-100">
                    <CButton
                        variant="outline"
                        color="success"
                        class="mr-3"
                        @click="add"
                    >Добавить</CButton>
                </div>
                <div v-else class="w-100 flex items-center">
                    <div class="w-2/6">
                        <CSelect
                            :options="deliveryTypes"
                            :value.sync="item.delivery_type"
                            :horizontal="{input: 'col-sm-12'}"
                            style="margin-bottom: 0;margin-right: 10px;"
                        />
                    </div>
                    <div class="w-2/6">
                        <CInput
                            v-model.number="item.price"
                            :disabled="!!item.free"
                            class="m-0 mr-2" />
                    </div>
                    <div class="w-1/6">
                        <CSwitch
                            color="dark"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="item.free"
                            class="ml-2" />
                    </div>
                    <div class="w-1/6 text-right">
                        <CButton
                            variant="outline"
                            color="danger"
                            class="mr-3"
                            @click="remove(item.id)"
                        >Удалить</CButton>
                    </div>
                </div>
            </div>

        </div>
    </CForm>

</template>

<script>
    import { DELIVERY_TYPE } from '@/utils/order';

    export default {

        name: 'Delivery',

        props: {
            data: {
                type: Array,
                default: () => ([])
            },
            addressDiscount: {
                type: Array,
                default: () => ([])
            }
        },
  
        data () {
            return {
                list: [],
                DELIVERY_TYPE
            }
        },

        computed: {
            deliveryTypes() {
                return [
                    {
                        label: 'Доставка до...',
                        value: 0
                    },
                    {
                        label: 'До двери',
                        value: DELIVERY_TYPE.DOOR
                    },
                    {
                        label: 'До точки встречи',
                        value: DELIVERY_TYPE.MEETING_POINT
                    },
                    {
                        label: 'Без доставки',
                        value: DELIVERY_TYPE.WITHOUT
                    },
                    {
                        label: 'Сборка заказа',
                        value: DELIVERY_TYPE.COLLECT
                    },
                ];
            }
        },

        watch: {
            data: {
                deep: true,
                handler: 'addButton'
            },
            list: {
                deep: true,
                handler: 'checkButton'
            }
        },

        mounted() {
            this.addButton();
        },
        
        methods: {
            add() {
                this.list = this.list.filter(item => !item.add);
                const id = this?.list[this?.list?.length - 1]?.id + 1 || 1;
                this.list.push({ id: id, delivery_type: null, price: 0, free: false });
            },

            remove(id) {
                this.list = this.list.filter(item => item.id !== id);
            },

            addButton() {
                const list = this.data || [];

                const haveButton = list.findIndex(item => item.add) === -1;
                const haveEmptyField = list.findIndex(item => (!item.delivery_type && item.delivery_type !== 0) || (!item.price && item.price !== 0) && !item.add) === -1;
                    
                if (haveButton && haveEmptyField) {
                    list.push({ id: 0, add: true });
                }

                this.list = list;
            },

            checkButton() {
                const haveButton = this.list.findIndex(item => item.add) === -1;
                const haveEmptyField = this.list.findIndex(item => ((!item.delivery_type && item.delivery_type !== 0) || (!item.price && item.price !== 0)) && !item.add) === -1;
                    
                if (haveButton && haveEmptyField) {
                    this.list.push({ id: 0, add: true });
                }

                this.$emit('update-address', this.list.filter(item => item.delivery_type));
            },
        }
    }
</script>
<style scoped>
.delivery_address_form {
    position: relative;
}

.bloked {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    background: rgba(255, 255, 255, .7);

    text-align: center;
}
</style>
